import { useState } from 'react';
import { Bell, Settings, User, LogOut } from 'lucide-react';
import { Link } from 'react-router-dom';

interface HeaderProps {
  userName?: string;
  userPicture?: string;
  onLogout?: () => void;
}

export function Header({ userName = 'User', userPicture, onLogout }: HeaderProps) {
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-brand-primary text-white">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-brand-secondary rounded-lg flex items-center justify-center">
            <span className="font-serif font-bold text-brand-primary text-lg">WF</span>
          </div>
          <div>
            <h1 className="font-serif font-semibold text-lg">Way Fong</h1>
            <p className="text-xs text-brand-tertiary opacity-80">Sales Leads</p>
          </div>
        </Link>

        {/* Right side */}
        <div className="flex items-center space-x-4">
          {/* Notifications */}
          <button className="relative p-2 rounded-lg hover:bg-white hover:bg-opacity-10 transition-colors">
            <Bell className="w-5 h-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-brand-secondary rounded-full" />
          </button>

          {/* Settings */}
          <Link
            to="/settings"
            className="p-2 rounded-lg hover:bg-white hover:bg-opacity-10 transition-colors"
          >
            <Settings className="w-5 h-5" />
          </Link>

          {/* User menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-3 pl-4 border-l border-white border-opacity-20 hover:bg-white hover:bg-opacity-10 rounded-lg p-2 transition-colors"
            >
              {userPicture ? (
                <img
                  src={userPicture}
                  alt={userName}
                  className="w-8 h-8 rounded-full"
                />
              ) : (
                <div className="w-8 h-8 bg-brand-bg rounded-full flex items-center justify-center">
                  <User className="w-4 h-4" />
                </div>
              )}
              <span className="text-sm font-medium hidden sm:block">{userName}</span>
            </button>

            {/* Dropdown menu */}
            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-50">
                <div className="px-4 py-2 border-b">
                  <p className="text-sm font-medium text-font-primary">{userName}</p>
                </div>
                {onLogout && (
                  <button
                    onClick={() => {
                      setShowUserMenu(false);
                      onLogout();
                    }}
                    className="w-full px-4 py-2 text-left text-sm text-font-primary hover:bg-gray-100 flex items-center space-x-2"
                  >
                    <LogOut className="w-4 h-4" />
                    <span>Sign out</span>
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
